import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function valuation_report() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Valuation Report</span>
                    </div>
                </section>

                <section class="web3bank">
                    <div data-lavalamp=""></div>
                    <div data-lavalamp=""></div>
                    <div class="content">
                        <div class="frame3d"></div>
                        <div class="pad texts">
                            <div data-lavalamp=""></div>

                            <div class="left">
                                <h1>NUGENESIS <br /><b>
                                    VALUATION REPORT</b></h1>
                                {/* <div class="subtitle">
                            CrossFi App </div> */}
                            </div>

                            <div class="right">
                                <div class="text">
                                    Nugenesis's Valuation- A comparative analysis between the Nugenesis Network and the Cardano Network. </div>
                                <div class="btns">
                                    <a href="document/NUGenesis Valuation Report.pdf" target="_blank" data-patt="track-btn" class="">View</a>
                                </div>
                            </div>


                        </div>
                    </div>
                </section>


                <section class="pad bank-benefits default">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Technical Innovation
                                    steps</h3>
                                <p class="subtitle">
                                    Valuation methodologies are notoriously difficult at the forefront of technical
                                    innovation. There are several considerations and approaches to take, the features
                                    of which are enumerated as follows: <br /><br /><br /><br />
                                    1.Dealing with Technical potential andecosystems<br /><br />
                                    2.Accepted valuation methodologies<br /><br />
                                    3.Closest competitor and distinguishing characteristics<br /><br />
                                    4.Cost of replication<br /><br />
                                    5.Additional associated assets
                                </p>

                            </div>
                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/pr-illustration 5.png" alt="" />
                        </div>
                    </div>

                </section>





            </main>
            <Footer />
        </>
    )
}